import React from 'react';
import PropTypes from 'prop-types';

import InvestmentCardContainer from '../components/InvestmentCardContainer';

const containerFactoryFactory = (
  props,
) => {
  const {
    gtkyApproved,
    status,
    fadeIn,
    fadeIndex,
    zIndex,
    id,
    reit,
    payoutTooltip,
    distributionTooltip,
    investmentTypeDisplay,
    noAnimate,
    cardHeight,
  } = props;

  const containerFactory = ({
    children,
    heights,
  }) => {
    const midOrShort = // Show the mid card for Debt, not GTKY approved, and closed.
      investmentTypeDisplay === 'Debt' && !gtkyApproved && status === 'status-40-closed' ?
        'mid' :
        // Otherwise, short cards for funded or completed deals without GTKY approval.
        'short';

    // Use a shorter card for completed / funded IOs. Switch between the shorter
    // types when the user is not GTKY approved for closed IOs.
    const heightKey = (status === 'status-30-active' || (status === 'status-40-closed' && !gtkyApproved)) ?
      midOrShort :
      // Default.
      'tall';
    const height = (cardHeight) ? heights[cardHeight] : heights[heightKey];

    return (
      <InvestmentCardContainer
        height={height}
        fadeIn={fadeIn}
        fadeIndex={fadeIndex}
        reit={reit}
        zIndex={zIndex}
        id={id}
        payoutTooltip={payoutTooltip}
        distributionTooltip={distributionTooltip}
        noAnimate={noAnimate}
      >
        { children }
      </InvestmentCardContainer>
    );
  };

  containerFactory.propTypes = {
    children: PropTypes.any,
    heights: PropTypes.shape({
      short: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.array,
      ]),
      mid: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.array,
      ]),
      tall: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.array,
      ]),
    }),
  };

  containerFactory.defaultProps = {
    heights: {
      short: [375, 375, 500, 500, 610],
      mid: [455, 455, 550, 550, 660],
      tall: [550, 550, 700, 700, 780],
    },
  };

  return containerFactory;
};

export default containerFactoryFactory;
